<template>
    <cusPopup
        overlayStyle="rgba(0, 0, 0, 0.2)"
        round="8px"
        v-model:showBoo="showToastBoo"
        mode="center"
        :closeOnClickOverlay="true"
        :safeAreaInsetBottom="false"
        bgColor="transprent"
        zIndex="9999999999"
        @close="initFun"
    >
        <view class="tipsBox">
            <image v-if="showType && showType != 'none'" :src="pngObj[showType]" mode="widthFix"></image>
            <view class="" v-if="showTitle">
                {{ showTitle }}
            </view>
        </view>
    </cusPopup>
</template>

<script setup>
    import { useDebounceClick } from '@/hooks/debounceClick';
    import { onMounted, ref, onUnmounted } from 'vue';
    import sucPng from '@/static/s_check.png';
    import errorPng from '@/static/error.png';
    import warningPng from '@/static/warning.png';
    const pngObj = {
        success: sucPng,
        error: errorPng,
        warning: warningPng
    };
    /*
  	title: ' 提示的文字'
  	showType: ' 提示的类型：success、error、warning'
  	showToastBoo: ' 控制开关'
  	durarion: ' 提示的持续时间：默认1500ms'
    success: ' 提示成功后的回调'
  */
    const initFun = () => {
        showToastBoo.value = false;
    };
    const showTitle = ref('');
    const showType = ref('');
    const showToastBoo = ref(false);
    let toastTimer = null;
    onMounted(() => {
        uni.$on(
            'showToast',
            useDebounceClick(({ title, durarion = 'none', type, success: callback }) => {
                showTitle.value = title;
                showType.value = type;
                showToastBoo.value = true;
                clearTimeout(toastTimer);
                toastTimer = setTimeout(
                    () => {
                        initFun();
                        if (typeof callback == 'function' && callback) {
                            callback();
                        }
                    },
                    durarion == 'none' || !durarion ? 1500 : durarion
                );
            })
        );
    });
    onUnmounted(() => {
        clearTimeout(toastTimer);
        uni.$off('showToast');
    });
</script>

<style lang="scss" scoped>
    .tipsBox {
        background: rgba(17, 17, 17, 0.7);
        text-align: center;
        padding: 15px 0px;
        min-width: 252px;
        max-width: 420px;
        position: relative;
        image {
            width: 50px;
            border-radius: 50%;
            margin-bottom: 10px;
        }

        view {
            color: #fff;
            // font-weight: bold;
            font-size: 24px;
            padding: 0px 20px;
        }
    }
</style>
